module.exports = __webpack_public_path__ + "img/dn.8ec5e272.png";